<template>
    <div class="comment-dialog">
        <v-row justify="center">
            <v-dialog v-model="dialog" width="800px">
            <template v-slot:activator="{ on }">
                <v-btn x-small depressed color="primary info--text" v-on="on">コメント</v-btn>
            </template>
            <v-card>
                <v-card-title>
                <span class="title">{{ticket.ticket_subject}}</span>
                </v-card-title>
                <v-card-text>{{ticket.ticket_number}}</v-card-text>
                <!-- <v-card-text>{{ticket.ticket_description}}</v-card-text> -->
                <v-card-text class="black--text subtitle-1">YourConciergeより</v-card-text>
                <v-card-text v-html="ticket.comment" class="black--text subtitle-1"></v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" text @click="dialog = false">Close</v-btn>
                </v-card-actions>
            </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>

<script>
export default {
    name: 'newTicketDialog',
    props:['ticket'],
    data(){
        return {
            dialog: false,
        }
    }
}
</script>